export default __webpack_public_path__ + "static/media/TreePlantingMobileHero.88bf048a.png";